/**
 * Scheduled launches (custom.launch_datetime).
 *
 * The gate that hides the buy button is evaluated in Liquid when the page is
 * rendered, so a shopper already sitting on the page at the launch time would
 * keep seeing the "on sale from" notice, and a page served from cache can be
 * stale either way. Reload on the moment so the server decides again.
 *
 * Reload rather than swapping the markup here: the buy buttons are a Liquid
 * form with variant state, and rebuilding that client side would be a second
 * implementation of it to keep in step.
 */
(function () {
  var notice = document.querySelector('[data-launch-at]');
  if (!notice) return;

  var launchMs = parseInt(notice.getAttribute('data-launch-at'), 10) * 1000;
  if (!launchMs) return;

  var RELOADED = 'launch-gate-reloaded';

  // sessionStorage throws in some privacy modes; the timer below is worth
  // keeping even when the stale-page guard is unavailable.
  function reloadedAlready() {
    try {
      return sessionStorage.getItem(RELOADED) === '1';
    } catch (e) {
      return true;
    }
  }

  function markReloaded(value) {
    try {
      if (value) sessionStorage.setItem(RELOADED, '1');
      else sessionStorage.removeItem(RELOADED);
    } catch (e) {
      /* no-op */
    }
  }

  var waitMs = launchMs - Date.now();

  if (waitMs <= 0) {
    // Launched, but this HTML still hides the button: a cached page. Reload
    // once — guarded, so a cache that keeps serving it can't loop.
    if (!reloadedAlready()) {
      markReloaded(true);
      window.location.reload();
    }
    return;
  }

  markReloaded(false);

  // setTimeout is only reliable over shortish spans, and a drop further out
  // than a day will have been re-rendered long before it opens.
  if (waitMs > 86400000) return;

  // Spread the reloads so a popular drop doesn't arrive as one burst.
  window.setTimeout(function () {
    window.location.reload();
  }, waitMs + 500 + Math.random() * 3000);
})();
